import React, { Fragment } from "react";
import { Label } from "reactstrap";
import { Safearea } from "../UI/Safearea/Safearea";
import { Row, Col } from "../UI/Customstrap/Customstrap";
import { Container } from "../UI/Container/Container";
import style from "./InConstruction.scss";
import { Header } from "../Layout/Header/Header";

export const InConstruction = () => {
    return (
      <Fragment>
        <Header title={"Proximamente..."}></Header>
        <Safearea>
          <Row className={style.headerTitle}>
              <Label>Proximamente...</Label>
          </Row>
          <Row>
            <Col>
              <Container>
                <div className={style.titleInfo}>Estamos trabajando en la construcción de esta funcionalidad.</div>
              </Container>
            </Col>
          </Row>
        </Safearea>
      </Fragment>
    );
};
